var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerizon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205 67",
    width: 205,
    height: 67,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lenovo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #8c98a4 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m205 8l-13.8 29.6h-3.7l-6.9-14.8h4.6l4.2 9l11.1-23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape copy",
    fillRule: "evenodd",
    className: "s0",
    d: "m152.7 22.8h8.7v4h0.1c2.2-3.1 5-4.9 9-4.9c6.3 0 10.3 4.6 10.3 11.1v19.3h-9v-17.5c0-3.2-1.6-5.4-4.7-5.4c-3.3 0-5.4 2.7-5.4 6.4v16.5h-9zm-2 14.8c0 8.8-6.2 15.6-15.6 15.6c-9.4 0-15.6-6.8-15.6-15.6c0-8.9 6.2-15.6 15.6-15.6c9.4 0 15.7 6.7 15.6 15.6zm-9.1 0c0-5.5-2.3-9-6.6-9c-4.2 0-6.5 3.5-6.5 9c0 5.4 2.3 8.9 6.5 8.9c4.3 0 6.7-3.5 6.6-8.9zm-47.7 7.8l13.8-15.4v-0.2h-13.8v-7.1h24.6v6.9l-13.7 15.3v0.2h14.3v7.1h-25.2zm-11.5-22.7h9v29.5h-9zm-21 0h8.6v4.9h0.2c2-3.5 4.4-5.1 7.9-5.1c0.8 0 1.3 0.1 1.8 0.2v7.8h-0.2c-5.6-0.8-9.3 2-9.3 8.1v13.5h-9zm-11.2 20.8h8.6c-0.5 2.5-2.4 5.1-4.9 6.9c-2.5 1.7-5.4 2.7-9.1 2.7c-9.7 0-15.6-6.8-15.6-15.7c0-8.8 6.2-15.5 15-15.5c4.2 0 7.5 1.2 9.9 3.5c3.5 3.2 5.2 8.3 5.2 14.6h-21.3c0.5 4 2.9 6.5 6.9 6.5c2.6 0 4.4-1.1 5.3-3zm-12.1-9.4h12c-0.3-3.5-2.5-5.8-5.7-5.8c-3.7 0-5.6 2.3-6.3 5.8zm-37.1-11.4h9.3l5.8 19h0.1l5.7-19h9.1l-10.3 29.5h-9.4zm81.3-10.5h9v8h-9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerizon);
export default __webpack_public_path__ + "static/media/verizon.83029f2ef2359a24501e4a7d360bca09.svg";
export { ForwardRef as ReactComponent };